export { PromoBanner } from "./PromoBanner";
export type { PromoBannerProps } from "./PromoBanner";
